/* eslint-disable react/prop-types */
import React from 'react';
import {
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  TimePicker,
} from 'antd';

import Utils from '../../../../Assets/Scripts/Utils';
import { createShowField } from '../../../../Components/ResourceFieldLayout/shouldRenderTaskField';
import CustomInstructorSelect from '../../../../Components/Schedule/CustomInstructorSelect';
import StageTagComponent from '../../../TaskList/Components/StageTagComponent';
import UploadFileField from '../UploadFileField';

function ScrollableDisabledTextArea({ value }) {
  return (
    <div
      style={{
        maxHeight: 144,
        overflowY: 'scroll',
        overflowX: 'hidden',
      }}
    >
      <Input.TextArea
        value={value}
        disabled={true}
        autoSize={{ minRows: 6 }}
        placeholder="o campo está vazio"
        style={{ resize: 'none' }}
      />
    </div>
  );
}

function FormGeneralFieldsComponent({
  fieldsPermissions,
  form,
  task,
  stages,
  combinedInstructorList,
  trainingsOptions,
  handleTaskUpdate,
  setUploadFileType,
  setUploadFileModalOpen,
  isTaskReadOnly,
  isEditing,
  scheduleType,
  fieldLayout,
  roleId,
  fieldNameFilter,
  hideSectionCard,
}) {
  const userData = JSON.parse(localStorage.getItem('conecta__userData'));
  const showField = createShowField(fieldsPermissions, fieldLayout, roleId, fieldNameFilter);

  const getTaskStage = () => {
    switch (scheduleType) {
      case 'mainInstructor':
        return task?.mainInstructor?.stage;
      case 'assistantInstructor':
        return task?.assistantInstructor?.stage;
      case 'driver':
        return (
          task?.driverList?.find((driver) => driver.userId === userData.id)?.stage ??
          'Estágio do Motorista não encontrado!'
        );
      default:
        return task?.stage;
    }
  };

  const currentStage = getTaskStage();
  const inner = (
    <>
      {/* Campo Produto */}
      {showField('Product') && (
        <Col span={24}>
          <Form.Item label="Produto" name={['product', 'name']}>
            <Input disabled placeholder="o campo está vazio" />
          </Form.Item>
        </Col>
      )}

      {/* Complemento */}
      {showField('Product') && (
        <Col span={24}>
          <Form.Item label="Complemento" name={['product', 'complement']}>
            <Input disabled placeholder="o campo está vazio" />
          </Form.Item>
        </Col>
      )}

      {/* Produto - Complemento */}
      {showField('Product') && (
        <Col span={24}>
          <Form.Item label="Produto - Complemento" name="productWithComplement">
            <Input disabled placeholder="o campo está vazio" />
          </Form.Item>
        </Col>
      )}

      {/* Detalhamento Técnico */}
      {showField('ProductDescription') && fieldsPermissions?.ProductDescription?.access !== 0 && (
        <Col span={24}>
          <Form.Item label="Detalhamento Técnico" name="productDescription">
            <ScrollableDisabledTextArea />
          </Form.Item>
        </Col>
      )}

      {/* Estágio */}
      {showField('Stage') && (
        <Col span={24}>
          <Form.Item
            label="Estágio"
            name={['stage', 'id']}
            getValueFromEvent={(_, object) => {
              if (!object) return null;

              return {
                ...object,
                name: object.label,
                id: object.value,
              };
            }}
          >
            <Select
              options={stages.map((stage) => ({
                label: stage.name,
                value: stage.id,
              }))}
              allowClear
              placeholder="o campo está vazio"
              optionFilterProp="label"
              showSearch
              dropdownStyle={{ borderRadius: 16 }}
              disabled
              style={{ display: 'none' }}
            />
            <StageTagComponent stage={currentStage} />
          </Form.Item>
        </Col>
      )}

      {showField('Date') && (
        <Col span={24}>
          <Form.Item
            label="Data"
            name="startDate"
            rules={[
              {
                required: fieldsPermissions?.Date.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{
                borderRadius: 16,
              }}
              disabled
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Horário de Início */}
      {showField('StartHour') && (
        <Col span={24}>
          <Form.Item
            label="Horário Início"
            name="startHour"
            rules={[
              {
                required: fieldsPermissions?.StartHour.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <TimePicker
              format="HH:mm"
              style={{ borderRadius: 16 }}
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.StartHour.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Recurso */}
      {showField('Resource') && (
        <Col span={24}>
          <Form.Item label="Recurso" name="resource">
            <Input disabled placeholder="o campo está vazio" />
          </Form.Item>
        </Col>
      )}

      {/* Campo Instrutor */}
      {showField('MainInstructor') && (
        <Col span={24}>
          <Form.Item
            label="Instrutor"
            name="mainInstructor"
            rules={[
              {
                required: fieldsPermissions?.MainInstructor.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
            getValueFromEvent={(value) => {
              if (!value) return value;

              const selectedInstructor = combinedInstructorList.find((item) => item.id === value);

              // 1 = Estágio Aguardando
              const waitingStage = stages.find(({ id }) => id === 1);

              return {
                ...selectedInstructor,
                userId: selectedInstructor.id,
                userName: selectedInstructor.name,
                stage: waitingStage,
              };
            }}
          >
            <CustomInstructorSelect
              type="mainInstructor"
              taskData={task}
              options={combinedInstructorList}
              fieldsPermissions={fieldsPermissions}
              isTaskReadOnly={task?.stage?.id === 5 || isTaskReadOnly}
              isEditing={isEditing}
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Instrutor Auxiliar */}
      {showField('AssistantInstructor') && (
        <Col span={24}>
          <Form.Item
            label="Instrutor Auxiliar"
            name="assistantInstructor"
            rules={[
              {
                required: fieldsPermissions?.AssistantInstructor.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
            getValueFromEvent={(value) => {
              if (!value) return value;

              const selectedInstructor = combinedInstructorList.find((item) => item.id === value);

              // 1 = Estágio Aguardando
              const waitingStage = stages.find(({ id }) => id === 1);

              return {
                ...selectedInstructor,
                userId: selectedInstructor.id,
                userName: selectedInstructor.name,
                stage: waitingStage,
              };
            }}
          >
            <CustomInstructorSelect
              type="assistantInstructor"
              taskData={task}
              options={combinedInstructorList}
              fieldsPermissions={fieldsPermissions}
              isTaskReadOnly={task?.stage?.id === 5 || isTaskReadOnly}
              isEditing={isEditing}
            />
          </Form.Item>
        </Col>
      )}

      {showField('InstructorValue') && (
        <Col span={24}>
          <Form.Item
            label="Valor Instrutor"
            name="instructorValue"
            rules={[
              {
                required: fieldsPermissions?.InstructorValue.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <InputNumber
              min={0}
              step={0.0001}
              formatter={Utils.priceFormatter}
              parser={Utils.priceParser}
              style={{ width: '100%' }}
              placeholder="o campo está vazio"
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.InstructorValue.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {showField('AssistantInstructorValue') && (
        <Col span={24}>
          <Form.Item
            label="Valor Instrutor Auxiliar"
            name="assistantInstructorValue"
            rules={[
              {
                required: fieldsPermissions?.AssistantInstructorValue.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <InputNumber
              min={0}
              step={0.0001}
              formatter={Utils.priceFormatter}
              parser={Utils.priceParser}
              style={{ width: '100%' }}
              placeholder="o campo está vazio"
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.AssistantInstructorValue.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo de Treinamentos */}
      {showField('Group') && (
        <Col span={24}>
          <Form.Item
            label="Treinamentos"
            name={['group', 'id']}
            rules={[
              {
                required: fieldsPermissions?.Group.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
            getValueFromEvent={(_, object) => {
              if (!object) return null;

              return {
                ...object,
                name: object.label,
                id: object.value,
              };
            }}
          >
            <Select
              options={trainingsOptions.map((trainingsOptions) => ({
                label: trainingsOptions.name,
                value: trainingsOptions.id,
              }))}
              allowClear
              placeholder="o campo está vazio"
              optionFilterProp="label"
              showSearch
              dropdownStyle={{ borderRadius: 16 }}
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.Group.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Campos de Texto */}
      {showField('QuoteTitle') && (
        <Col span={24}>
          <Form.Item
            label="Nome do Negócio"
            name="quoteTitle"
            rules={[
              {
                required: fieldsPermissions?.QuoteTitle.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.QuoteTitle.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {showField('TrainingTransportation') && (
        <Col span={24}>
          <Form.Item
            label="Transporte Oficial"
            name="trainingTransportation"
            rules={[
              {
                required: fieldsPermissions?.TrainingTransportation.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.TrainingTransportation.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {showField('QuoteResponsible') && (
        <Col span={24}>
          <Form.Item
            label="Responsável pelo Negócio"
            name="quoteResponsible"
            rules={[
              {
                required: fieldsPermissions?.QuoteResponsible.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.QuoteResponsible.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {showField('DealOportunity') && (
        <Col span={24}>
          <Form.Item
            label="Valor da Oportunidade"
            name="dealOportunity"
            rules={[
              {
                required: fieldsPermissions?.DealOportunity.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealOportunity.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {showField('DealId') && (
        <Col span={24}>
          <Form.Item
            label="Número Negócio"
            name="dealId"
            rules={[
              {
                required: fieldsPermissions?.DealId.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealId.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {showField('DealTitle') && (
        <Col span={24}>
          <Form.Item
            label="Nome do Negócio"
            name="dealTitle"
            rules={[
              {
                required: fieldsPermissions?.DealTitle.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealTitle.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {showField('DealClient') && (
        <Col span={24}>
          <Form.Item
            label="Cliente"
            name="dealClient"
            rules={[
              {
                required: fieldsPermissions?.DealClient.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealClient.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Nome Fantasia */}
      {showField('DealClientCommercialName') &&
        fieldsPermissions?.DealClientCommercialName?.access !== 0 && (
          <Col span={24}>
            <Form.Item label="Nome Fantasia" name="dealClientCommercialName">
              <Input disabled={true} placeholder="o campo está vazio" />
            </Form.Item>
          </Col>
        )}

      {showField('DealContractedCompany') && (
        <Col span={24}>
          <Form.Item
            label="Empresa Contratada"
            name="dealContractedCompany"
            rules={[
              {
                required: fieldsPermissions?.DealContractedCompany.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealContractedCompany.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {showField('DealTrainingCenterAdress') && (
        <Col span={24}>
          <Form.Item
            label="Endereço do CT para Treinamento"
            name="dealTrainingCenterAddress"
            rules={[
              {
                required: fieldsPermissions?.DealTrainingCenterAdress.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealTrainingCenterAdress.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {showField('DealPaymentCondition') && (
        <Col span={24}>
          <Form.Item
            label="Condição de Pagamento"
            name="dealPaymentCondition"
            rules={[
              {
                required: fieldsPermissions?.DealPaymentCondition.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealPaymentCondition.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {showField('DealPaymentForm') && (
        <Col span={24}>
          <Form.Item
            label="Forma de Pagamento"
            name="dealPaymentForm"
            rules={[
              {
                required: fieldsPermissions?.DealPaymentForm.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealPaymentForm.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Ordem de Compra Obrigatória */}
      {showField('ObrigatoryBuyOrder') && (
        <Col span={24}>
          <Form.Item
            label="Ordem de Compra Obrigatória"
            name="obrigatoryBuyOrder"
            rules={[
              {
                required: fieldsPermissions?.ObrigatoryBuyOrder.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.ObrigatoryBuyOrder.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Data Limite para Faturamento */}
      {showField('DealEndDateInvoice') && (
        <Col span={24}>
          <Form.Item
            label="Data Limite para Faturamento Oficial"
            name="dealEndDateInvoice"
            rules={[
              {
                required: fieldsPermissions?.DealEndDateInvoice.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealEndDateInvoice.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Retenção Tributária */}
      {showField('DealTributaryRetention') && (
        <Col span={24}>
          <Form.Item
            label="Retenção Tributária"
            name="dealTributaryRetention"
            rules={[
              {
                required: fieldsPermissions?.DealTributaryRetention.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealTributaryRetention.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Cliente Prioritário */}
      {showField('DealPrioritaryClient') && (
        <Col span={24}>
          <Form.Item
            label="Cliente Prioritário"
            name="dealPrioritaryClient"
            rules={[
              {
                required: fieldsPermissions?.DealPrioritaryClient.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealPrioritaryClient.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Observação Específica */}
      {showField('DealClientObservation') && (
        <Col span={24}>
          <Form.Item
            label="Observação Específica"
            name="dealClientObservation"
            rules={[
              {
                required: fieldsPermissions?.DealClientObservation.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input.TextArea
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealClientObservation.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Necessidade do Cliente */}
      {showField('DealClientNeed') && fieldsPermissions?.DealClientNeed?.access !== 0 && (
        <Col span={24}>
          <Form.Item label="Necessidade do Cliente" name="dealClientNeed">
            <Input.TextArea
              disabled={true}
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Pós venda */}
      {showField('DealPostSale') && fieldsPermissions?.DealPostSale?.access !== 0 && (
        <Col span={24}>
          <Form.Item label="Pós venda" name="dealPostSale">
            <Input.TextArea
              disabled={true}
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Datas de Treinamento Oficial */}
      {showField('DealOfficialTrainingDates') &&
        fieldsPermissions?.DealOfficialTrainingDates?.access !== 0 && (
          <Col span={24}>
            <Form.Item label="Datas de Treinamento Oficial" name="dealOfficialTrainingDates">
              <Input.TextArea
                disabled={true}
                autoSize={{ maxRows: 6 }}
                placeholder="o campo está vazio"
              />
            </Form.Item>
          </Col>
        )}

      {/* Indústria */}
      {showField('DealIndustry') && fieldsPermissions?.DealIndustry?.access !== 0 && (
        <Col span={24}>
          <Form.Item label="Indústria" name="dealIndustry">
            <Input.TextArea
              disabled={true}
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Tipo de negócio */}
      {showField('DealType') && fieldsPermissions?.DealType?.access !== 0 && (
        <Col span={24}>
          <Form.Item label="Tipo de negócio" name="dealType">
            <Input.TextArea
              disabled={true}
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Forma de Pagamento Negociada */}
      {showField('DealPaymentFormNegotiated') && (
        <Col span={24}>
          <Form.Item
            label="Forma de Pagamento Negociada"
            name="dealPaymentFormNegotiated"
            rules={[
              {
                required: fieldsPermissions?.DealPaymentFormNegotiated.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealPaymentFormNegotiated.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Condição de Pagamento Negociada */}
      {showField('DealPaymentConditionNegotiated') && (
        <Col span={24}>
          <Form.Item
            label="Condição de Pagamento Negociada"
            name="dealPaymentConditionNegotiated"
            rules={[
              {
                required: fieldsPermissions?.DealPaymentConditionNegotiated.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealPaymentConditionNegotiated.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Emissão Nota Fiscal Oficial */}
      {showField('OfficialInvoiceIssue') && (
        <Col span={24}>
          <Form.Item
            label="Emissão Nota Fiscal Oficial"
            name="officialInvoiceIssue"
            rules={[
              {
                required: fieldsPermissions?.OfficialInvoiceIssue.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.OfficialInvoiceIssue.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Quantidade de Turmas */}
      {showField('QtyClass') && (
        <Col span={24}>
          <Form.Item
            label="Quantidade de Turmas"
            name="qtyClass"
            rules={[
              {
                required: fieldsPermissions?.QtyClass.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.QtyClass.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Alunos por Turma */}
      {showField('QtyStudentsPerClass') && (
        <Col span={24}>
          <Form.Item
            label="Alunos por Turma"
            name="qtyStudentsPerClass"
            rules={[
              {
                required: fieldsPermissions?.QtyStudentsPerClass.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.QtyStudentsPerClass.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Alunos Treinados */}
      {showField('StudentsTrained') && (
        <Col span={24}>
          <Form.Item
            label="Alunos Treinados"
            name="qtyStudentsTrained"
            rules={[
              {
                required: fieldsPermissions?.StudentsTrained.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.StudentsTrained.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Alunos Transportados */}
      {showField('StudentsTransported') && (
        <Col span={24}>
          <Form.Item
            label="Alunos Transportados"
            name="qtyStudentsTransported"
            rules={[
              {
                required: fieldsPermissions?.StudentsTransported.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.StudentsTransported.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Centro de Treinamento */}
      {showField('TrainingCenter') && (
        <Col span={24}>
          <Form.Item
            label="Centro de Treinamento"
            name="trainingCenter"
            rules={[
              {
                required: fieldsPermissions?.TrainingCenter.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.TrainingCenter.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Data do Agendamento */}
      {showField('DateScheduling') && (
        <Col span={24}>
          <Form.Item
            label="Data do Agendamento"
            name="dateScheduling"
            rules={[
              {
                required: fieldsPermissions?.DateScheduling.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{
                borderRadius: 16,
              }}
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DateScheduling.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Lista de Presença Inicial */}
      {showField('InitialAttendanceList') && (
        <Col span={24}>
          <Form.Item label="Lista de Presença Inicial" name="initialAttendanceDocList">
            <UploadFileField
              handleTaskUpdate={handleTaskUpdate}
              form={form}
              task={task}
              fieldName="initialAttendanceDocList"
              fieldPermission={fieldsPermissions?.InitialAttendanceList}
              isTaskReadOnly={task?.stage?.id === 5 || isTaskReadOnly}
              isEditing={isEditing}
              setUploadFileType={setUploadFileType}
              setUploadFileModalOpen={setUploadFileModalOpen}
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Lista de Presença Final  */}
      {showField('FinalAttendanceList') && (
        <Col span={24}>
          <Form.Item label="Lista de Presença Final" name="finalAttendanceDocList">
            <UploadFileField
              handleTaskUpdate={handleTaskUpdate}
              form={form}
              task={task}
              fieldName="finalAttendanceDocList"
              fieldPermission={fieldsPermissions?.FinalAttendanceList}
              isTaskReadOnly={task?.stage?.id === 5 || isTaskReadOnly}
              isEditing={isEditing}
              setUploadFileType={setUploadFileType}
              setUploadFileModalOpen={setUploadFileModalOpen}
            />
          </Form.Item>
        </Col>
      )}

      {/* Formulário do Instrutor  */}
      {showField('InstructorForm') && (
        <Col span={24}>
          <Form.Item label="Formulário do Instrutor" name="instructorForm">
            <UploadFileField
              handleTaskUpdate={handleTaskUpdate}
              form={form}
              task={task}
              fieldName="instructorForm"
              fieldPermission={fieldsPermissions?.InstructorForm}
              isTaskReadOnly={task?.stage?.id === 5 || isTaskReadOnly}
              isEditing={isEditing}
              setUploadFileType={setUploadFileType}
              setUploadFileModalOpen={setUploadFileModalOpen}
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Pedido de Compra */}
      {showField('DealBuyOrder') && (
        <Col span={24}>
          <Form.Item label="Pedido de Compra">
            {form.getFieldValue('downloadDealBuyOrder') ? (
              <a
                href={form.getFieldValue('downloadDealBuyOrder')}
                target="_blank"
                rel="noopener noreferrer"
              >
                Abrir
              </a>
            ) : (
              <p style={{ color: 'orange' }}>Pendente</p>
            )}
          </Form.Item>
        </Col>
      )}

      {/* Pedido de Compra Oficial 2 */}
      {showField('DownloadDealBuyOrderOfficial2') &&
        fieldsPermissions?.DownloadDealBuyOrderOfficial2?.access !== 0 && (
          <Col span={24}>
            <Form.Item label="Pedido de Compra Oficial 2">
              {(() => {
                const official2Files = form.getFieldValue('downloadDealBuyOrderOfficial2');
                if (!Array.isArray(official2Files) || official2Files.length === 0) {
                  return <Input disabled={true} placeholder="o campo está vazio" />;
                }

                return official2Files.map((file, index) => (
                  <div key={file?.url || index}>
                    <a
                      href={Utils.resolveBitrixDownloadUrl(file?.url)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Abrir
                    </a>
                  </div>
                ));
              })()}
            </Form.Item>
          </Col>
        )}

      {/* Anexos Extras */}
      {showField('DownloadDealExtraAttachments') &&
        fieldsPermissions?.DownloadDealExtraAttachments?.access !== 0 && (
          <Col span={24}>
            <Form.Item label="Anexos Extras">
              {(() => {
                const extraAttachmentFiles = form.getFieldValue('downloadDealExtraAttachments');
                if (!Array.isArray(extraAttachmentFiles) || extraAttachmentFiles.length === 0) {
                  return <Input disabled={true} placeholder="o campo está vazio" />;
                }

                return extraAttachmentFiles.map((file, index) => (
                  <div key={file?.url || index}>
                    <a
                      href={Utils.resolveBitrixDownloadUrl(file?.url)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {Utils.attachmentDownloadLabel(file)}
                    </a>
                  </div>
                ));
              })()}
            </Form.Item>
          </Col>
        )}

      {/* Campo Termo de Aceite */}
      {showField('AcceptTerm1') && (
        <Col span={24}>
          <Form.Item label="Termo de Aceite">
            {form.getFieldValue('downloadAcceptTerm1') ? (
              <a
                href={form.getFieldValue('downloadAcceptTerm1')}
                target="_blank"
                rel="noopener noreferrer"
              >
                Abrir
              </a>
            ) : (
              <p style={{ color: 'orange' }}>Pendente</p>
            )}
          </Form.Item>
        </Col>
      )}

      {/* Termo de Aceite Assinado */}
      {showField('AcceptTerm2') && (
        <Col span={24}>
          <Form.Item label="Termo de Aceite Assinado">
            {form.getFieldValue('downloadAcceptTerm2') ? (
              <a
                href={form.getFieldValue('downloadAcceptTerm2')}
                target="_blank"
                rel="noopener noreferrer"
              >
                Abrir
              </a>
            ) : (
              <p style={{ color: 'orange' }}>Pendente</p>
            )}
          </Form.Item>
        </Col>
      )}

      {/* Data de Recebimento do Termo Assinado */}
      {showField('DateUploadAcceptTerm2') && (
        <Col span={24}>
          <Form.Item
            label="Data de Recebimento do Termo Assinado"
            name="dateUploadAcceptTerm2"
            rules={[
              {
                required: fieldsPermissions?.DateUploadAcceptTerm2.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{
                borderRadius: 16,
              }}
              disabled={
                fieldsPermissions?.DateUploadAcceptTerm2.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Documentação Enviada */}
      {showField('HasDocumentation') && (
        <Col span={24}>
          <Form.Item label="Documentação Enviada" name="hasDocumentation" valuePropName="checked">
            <Checkbox
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.HasDocumentation.access !== 2 ||
                !form.getFieldValue('finalAttendanceDocList') ||
                form.getFieldValue('finalAttendanceDocList')?.length === 0 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Aceita Encaixe */}
      {showField('AcceptSharedTraining') && (
        <Col span={24}>
          <Form.Item label="Aceita Encaixe" name="acceptSharedTraining" valuePropName="checked">
            <Checkbox
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.AcceptSharedTraining.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Lista de Presença Verificada */}
      {showField('AttendanceListChecked') && (
        <Col span={24}>
          <Form.Item
            label="Lista de Presença Verificada"
            name="attendanceListChecked"
            valuePropName="checked"
          >
            <Checkbox
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.AttendanceListChecked.access !== 2 ||
                !form.getFieldValue('finalAttendanceDocList') ||
                isTaskReadOnly ||
                !isEditing
              }
            />
          </Form.Item>
        </Col>
      )}

      {/* Produtos do Negócio */}
      {showField('QuoteProducts') && (
        <Col span={24}>
          <Form.Item
            label="Produtos do Negócio"
            name="quoteProducts"
            rules={[
              {
                required: fieldsPermissions?.QuoteProducts.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input.TextArea
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.QuoteProducts.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Observação Negócio */}
      {showField('DealNotes') && (
        <Col span={24}>
          <Form.Item
            label="Observação Negócio"
            name="dealNotes"
            rules={[
              {
                required: fieldsPermissions?.DealNotes.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input.TextArea
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.DealNotes.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Observação Comercial */}
      {showField('CommercialNotes') && (
        <Col span={24}>
          <Form.Item
            label="Observação Comercial"
            name="commercialNotes"
            rules={[
              {
                required: fieldsPermissions?.CommercialNotes.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input.TextArea
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.CommercialNotes.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Observação Logística */}
      {showField('LogisticsNotes') && (
        <Col span={24}>
          <Form.Item
            label="Observação Logística"
            name="logisticsNotes"
            rules={[
              {
                required: fieldsPermissions?.LogisticsNotes.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input.TextArea
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.LogisticsNotes.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Observação Financeiro */}
      {showField('FinanceNotes') && (
        <Col span={24}>
          <Form.Item
            label="Observação Financeiro"
            name="financeNotes"
            rules={[
              {
                required: fieldsPermissions?.FinanceNotes.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input.TextArea
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.FinanceNotes.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Observação CT */}
      {showField('CtNotes') && (
        <Col span={24}>
          <Form.Item
            label="Observação CT"
            name="ctNotes"
            rules={[
              {
                required: fieldsPermissions?.CtNotes.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input.TextArea
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.CtNotes.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {/* Campo Observação Instrutor */}
      {showField('InstructorNotes') && (
        <Col span={24}>
          <Form.Item
            label="Observação Instrutor"
            name="instructorNotes"
            rules={[
              {
                required: fieldsPermissions?.InstructorNotes.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <Input.TextArea
              disabled={
                task?.stage?.id === 5 ||
                fieldsPermissions?.InstructorNotes.access !== 2 ||
                isTaskReadOnly ||
                !isEditing
              }
              autoSize={{ maxRows: 6 }}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}
    </>
  );

  if (hideSectionCard) {
    return inner;
  }

  return (
    <Col span={24}>
      <Card title="Geral" bordered={false} className="task-form-section-card">
        {inner}
      </Card>
    </Col>
  );
}

export default FormGeneralFieldsComponent;
